import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withPreloading } from '@angular/router';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { MarkdownModule } from 'ngx-markdown';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { ApiHttpInterceptor } from './app/shared/utils/ApiHttpInterceptor';
import { CachedTranslateLoader } from './app/shared/utils/cached-translate-loader';
import { GlobalErrorHandler } from './app/shared/utils/GlobalErrorHandler';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      MarkdownModule.forRoot(),
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
      MatProgressBarModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new CachedTranslateLoader(http),
          deps: [HttpClient, HttpBackend],
        },
        defaultLanguage: 'en',
      }),
    ),
    provideRouter(APP_ROUTES, withComponentInputBinding(), withPreloading(PreloadAllModules)),
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        disableTooltipInteractivity: true,
        /* showDelay: 0,
                      hideDelay: 0,
                      touchendHideDelay: 1500,
                      position: 'above', */
      },
    },
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },

    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: HTTP_INTERCEPTORS, useClass: ApiHttpInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    provideCacheableAnimationLoader(),
    {
      provide: 'ICommunicationService',
      useExisting: environment.communicationService,
    },
    JwtHelperService,
  ],
}).catch((err) => console.error(err));
